const checkUserSignatureCount = async (userId: string) => {
  try {
    const response = await fetch("/api/check-signature-count", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ userId }),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error checking signature count:", error);
    return { success: false, error: error.message };
  }
};

export default checkUserSignatureCount;
